



















































import { Prop, Component, Vue } from "vue-property-decorator";
import ServiceTaskForm, {
  ServiceTaskFormData
} from "../components/ServiceTaskForm.vue";
import ProjectBar, {
  Props as ProjectBarProps
} from "../../../components/ProjectBar.vue";
import {
  getServiceTask,
  ServiceTask
} from "@/servicetask/api/service-tasks-api";
import { getProject, Project } from "@/api/project-api";

@Component({
  components: { ServiceTaskForm, ProjectBar }
})
export default class EditServiceTaskModal extends Vue {
  @Prop({ type: Boolean }) open?: boolean;
  @Prop({ required: true }) taskTypeId!: number;
  @Prop({}) taskId?: number;

  task: ServiceTask | null = null;
  project: Project | null = null;
  data: ServiceTaskFormData | null = null;

  get projectBarProps(): ProjectBarProps | null {
    if (!this.project) {
      return null;
    }
    return {
      name: this.project.name,
      icon: this.project.icon,
      status: this.project.status
    };
  }

  get visible(): boolean {
    return Boolean(this.open && this.taskId);
  }

  get onMobile() {
    return this.$store.getters.onMobile;
  }

  hide() {
    (this.$refs["modal"] as any).hide();
  }

  async reset() {
    this.task = null;
    this.project = null;
    this.data = null;

    if (!this.taskId) {
      throw new Error("task id is required");
    }
    const task = await getServiceTask(this.taskId, this.taskTypeId);
    if (!task) {
      throw new Error("task is not found.");
    }
    this.data = {
      ...task,
      pending: task.pending,
      staff: String((task.project.staff && task.project.staff.id) || ""),
      otherTasks: task.otherTasks,
      constructionTasks: task.constructionTasks
    };
    this.task = task;
    this.project = await getProject(task.project.id);
  }

  async save() {
    await (this.$refs["form"] as ServiceTaskForm).submit();
    this.hide();
    this.$emit("update");
  }
}
